import React__default from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber } from '../utils/phoneNumber.js';

var Tel = function Tel(_ref) {
  var className = _ref.className,
    phoneNumber = _ref.phoneNumber;
  var formattedNum = formatPhoneNumber(phoneNumber);
  return /*#__PURE__*/React__default.createElement("a", {
    className: className,
    href: "tel:" + formattedNum
  }, formattedNum);
};
Tel.displayName = "Tel";
Tel.propTypes = {
  phoneNumber: PropTypes.string.isRequired
};

export { Tel, Tel as default };
